export const NOT_FOUND_NEXT_LECTURE_INFO_ERROR_STATUS_CODE = 404
export const NOT_FOUND_NEXT_LECTURE_INFO_ERROR_CODE = 'NOT_FOUND_NEXT_LECTURE_INFO'
export const NOT_FOUND_NEXT_LECTURE_INFO_ERROR_MESSAGE = 'Next lecture info not found'
